import { Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"

import { Container, WYSIWYG, type FC } from ".."

type TextProps = {
  title?: string
  text: string
}

const Text: FC<TextProps> = ({ title, text }) => {
  return (
    <Container maxWidth={1200} py={{ xs: 10, md: 30 }}>
      {title && (
        <Typography variant="heading.2xl" component="h2" mb={15}>
          {title}
        </Typography>
      )}
      <WYSIWYG
        content={text}
        sx={(theme) => ({
          "h1, h2, h3, h4, h5, h6": {
            color: theme.palette["neutral.700"].main,
            mb: 5,
          },

          "p": {
            color: alpha(theme.palette["neutral.700"].main, 0.7),
          },

          "hr": {
            border: 0,
            borderTop: `1px solid ${theme.palette["neutral.200"].main}`,
            my: 30,
          },
          "a": {
              textDecoration: "none",
            },
        })}
      />
    </Container>
  )
}
export default Text
